/**
 * Helper
 */
var helper = require('../../helper'),
		dataTables_buttons = [

			{
				extend: 'csv',
				text: 'Export as CSV',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default'
			},
			{
				extend: 'pdf',
				text: 'Export as PDF',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default',
				orientation: 'landscape'
			},
			{
				extend: 'print',
				text: 'Print table',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default'
			},
			{
				extend: 'colvis',
				className: 'btn btn-default'
			}

		];

$(function() {
    var $datatable = $('#datatable-all-client-contacts'),
    $dt;

	$dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
	    "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
	    "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
	    "ajax": {
		    "url": helper.getOrigin() + "/api/clients/contacts",
		    "method": 'POST',
		    "data": function ( d ) {
			    d.company = $('input[id=company]').val();
		    }
	    },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'name', name: 'name', className: 'data-export'},
	        {data: 'company', name: 'company', className: 'data-export'},
	        {data: 'clientStatus', name: 'clientStatus', className: 'data-export'},
	        {data: 'company_address', name: 'company_address', className: 'data-export', visible: false},
	        {data: 'web', name: 'web', className: 'data-export', visible: false},
            {data: 'companyPhoneNumber', name: 'companyPhoneNumber', className: 'data-export', visible: false},
	        {data: 'vip_amount', name: 'vip_amount', className: 'data-export', visible: false},
	        {data: 'savings_made', name: 'savings_made', className: 'data-export', visible: false},
            {data: 'email', name: 'userEmail', className: 'data-export'},
            {data: 'phone', name: 'userPhoneNumber', className: 'data-export'},
            {data: 'department', name: 'department', className: 'data-export'},
            {data: 'job_title', name: 'job_title', className: 'data-export'},
	        {data: 'reports_to', name: 'reports_to', className: 'data-export'},
	        {data: 'address', name: 'address', className: 'data-export'},
	        {data: 'description', name: 'description', className: 'data-export', visible: false},
	        {data: 'internal_info', name: 'internal_info', className: 'data-export', visible: false},
	        {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ]
    });

	$('#search-form').on('submit', function(e) {
		$dt.draw();
		e.preventDefault();
	});

});
